export default function Datenschutz() {
  return <>Datenschutz</>;
}
